// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WzRU","label":"styles_label__1IP86"};